var React = require('react');

function Pin2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 16.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z","stroke":"#D22128","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15 28c5-5 10-9.477 10-15S20.523 3 15 3 5 7.477 5 13s5 10 10 15Z","stroke":"#D22128","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Pin2.defaultProps = {"width":"30","height":"30","fill":"none"};

module.exports = Pin2;

Pin2.default = Pin2;
